import { render, staticRenderFns } from "./Identidad.vue?vue&type=template&id=0b3096c2&scoped=true"
import script from "./Identidad.vue?vue&type=script&lang=js"
export * from "./Identidad.vue?vue&type=script&lang=js"
import style0 from "./Identidad.vue?vue&type=style&index=0&id=0b3096c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3096c2",
  null
  
)

export default component.exports